import { useMemo } from 'react';
import { menuListAdapter } from '../libs/menuAdapter';
import { useQuery } from '@tanstack/react-query';
import { homeAPI } from '../api/homeAPI';
export const useGetMenu = (branch?: number) => {
  const initData = useMemo(() => ({ menu: menuListAdapter() }), []);
  const { data = initData, isLoading } = useQuery({
    queryKey: ['menu', branch],
    queryFn: async () => {
      const res = await homeAPI.getMenus(branch!);
      console.log('[getMenu] raw server response:', res.data);
      return res;
    },
    select: data => ({
      menu: menuListAdapter(data.data),
    }),
    enabled: !!branch,
  });
  return {
    ...data,
    isLoading,
  };
};
